import type { DeviceResourceDiagnosticsReadApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { GridCallbackDetails, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';
import type { GridApiPremium } from '@mui/x-data-grid-premium';
import type { GridRowParams } from '@mui/x-data-grid-pro';
import type { MutableRefObject } from 'react';
import { useMemo } from 'react';
import type { DeviceDiagnosticsListContentGridProps } from '../DeviceDiagnosticsListContent.model';

export function useGridPropsSetup({
  handleRowClick,
  datagridRef,
  total,
  getRowId,
  isLoading,
  shouldDisplayGrid,
  onPaginationModelChange,
  onSortModelChange,
}: {
  readonly handleRowClick: ({ row }: GridRowParams<DeviceResourceDiagnosticsReadApi>) => void;
  readonly datagridRef: MutableRefObject<GridApiPremium>;
  readonly total: number;
  readonly getRowId: (element: DeviceResourceDiagnosticsReadApi) => string;
  readonly isLoading: boolean;
  readonly shouldDisplayGrid: boolean;
  readonly onPaginationModelChange: (model: GridPaginationModel, details: GridCallbackDetails<'pagination'>) => void;
  readonly onSortModelChange: (sort: GridSortModel, details: GridCallbackDetails) => void;
}) {
  return useMemo<DeviceDiagnosticsListContentGridProps>(
    () => ({
      handleRowClick,
      total,
      getRowId,
      isLoading,
      shouldDisplayGrid,
      handlePaginationModelChange: onPaginationModelChange,
      handleSortModelChange: onSortModelChange,
      datagridRef,
    }),
    [
      handleRowClick,
      total,
      getRowId,
      isLoading,
      shouldDisplayGrid,
      onPaginationModelChange,
      onSortModelChange,
      datagridRef,
    ],
  );
}
